import { bl_cms_calendar_post_link_RowClass } from "../../../dbschema/bl_cms_event_post_link.model";
import { BaseContainerModel } from "../../base-container.model";

export class CmsEventPostLinkContainerModel extends BaseContainerModel {
  bl_cms_calendar_post_link: bl_cms_calendar_post_link_RowClass =
    new bl_cms_calendar_post_link_RowClass();
}
